
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="1000px"
      transition="dialog-transition"
      style="border-radius: 40px;"
    >
      <base-card>
        <template slot="title">
          <span class="text-capitalize pa-3 font-weight-bold">
            {{ $tc('companies.new')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="companyForm" class="px-3">
            <company-form :one_company="new_company"></company-form>
          </v-form>
          
        </template>


        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelCompany" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveCompany" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>

    <dialog-loading v-if="loading" loadingText="saving" ></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';
import AddressForm from '../../shared/forms/AddressForm.vue';
import CompanyForm from './shared/CompanyForm.vue';

export default {
  name: 'DialogCreateCompany',
  mixins: [ validations ],
  components: {
    AddressForm,
    CompanyForm
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      loading: false,
      
      new_company: {
        name: null,
        second_name: null,
        document: null,
        document_kind: null,
        status: 'active',
        // json_attributes
        phone: null,
        rg: null,
        email: null,

        address: {
          street: null,
          number: null,
          district: null,
          city: null,
          state: null,
          zip: null,
          complement: null,
        },
        
        pay_status: null,
        payment_option: null,
        plan: null,
        renewal_date: null,
        renewal_kind: null,
        subscription_date: this.$dayjs().startOf('day').format(),
      },
    }
  },
  methods: {
    cancelCompany(){
      this.dialog=false
    },
    saveCompany(){
      if (this.$refs.companyForm.validate()){
        this.loading = true
        let {renewal_date, ...mov} = this.new_company
        renewal_date = this.$dayjs(renewal_date).add(12, 'hour').format()
        Api.Company.create(this.new_company).then(r=> {
          this.$router.go(-1)
        }).catch(err=> {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
  
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>